import React from 'react';

import * as Style from './CategoryNavProductsModalDesktop.style';
import { ProductLinks } from '..';
import { CurologySiteAndShopNavCardFlag } from 'consts/featureFlagsAndMetrics';
import { useFlag } from 'utils/featureFlagsAndMetrics';
import { isSafeNavHref } from 'utils/isSafeNavHref';

export const CategoryNavProductsModalDesktop = () => {
  const curologySiteAndShopNavCard = useFlag<
    CurologySiteAndShopNavCardFlag | undefined
  >('curology-site-and-shop-nav-card');

  const cardImage = curologySiteAndShopNavCard && (
    <img
      src={curologySiteAndShopNavCard.desktopImageUrl}
      alt={curologySiteAndShopNavCard.altText ?? 'Shop promotion'}
      width={curologySiteAndShopNavCard.desktopImageWidth}
      height={curologySiteAndShopNavCard.desktopImageHeight}
    />
  );

  return (
    <React.Fragment>
      <Style.CategoryNavLinksContainer>
        <ProductLinks />
      </Style.CategoryNavLinksContainer>
      <Style.CategoryNavImageContainer>
        {/* A plain anchor, not a Gatsby Link: linkUrl is remote config and may
            point outside this build (an external host, or /shop/*, which
            Gatsby's router does not own). It is checked because remote config
            could otherwise carry a `javascript:` payload; an unusable
            destination leaves the image rendered but unlinked. */}
        {curologySiteAndShopNavCard &&
        isSafeNavHref(curologySiteAndShopNavCard.linkUrl) ? (
          <a href={curologySiteAndShopNavCard.linkUrl}>{cardImage}</a>
        ) : (
          cardImage
        )}
      </Style.CategoryNavImageContainer>
    </React.Fragment>
  );
};
